module.exports = __webpack_public_path__ + "img/rot05.ca32d0d0.jpg";